import { http } from "Utils/http";
import DatatableBase from 'Components/Datatable/DatatableBase'
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { formatDate, isInObject } from "Utils/utilityFunctions";
import { ROLES } from "Utils/constants";
import { httpDownload } from "Utils/httpDownload";
import { ICONS } from "Utils/icons";


const DataSubmissionActivityTable = ({submissionFormat, submissionState, role, isVendor}) => {
  	const loginInfo = useSelector(state => state.loginInfo);

	let location = useLocation();
  	//console.log(location);
    
    //const navigate = useNavigate();
    //const dispatch = useDispatch();
    
     const [sortColumn, setSortColumn] = useState({
        sortField: "submitDate",
        sortDirection: "desc"
    });

    const [filter, setFilter] = useState(null);
  
	useEffect(()=>{
	    var passedData = location.state;
	    
	    if(isInObject("filter",passedData)) {
	        //console.log(passedData.filter);
	        setFilter(passedData.filter);
	    }
	    else {
	        setFilter({
	            startIndex:0,
	            entryPerPage:10,
	            sortingColumn:sortColumn.sortField,
	            sortingOrder:sortColumn.sortDirection,
	            searchTerm:""
	        });
	    }
	    //console.log(filter);

	},[])

    const getTest = async (filter) => {   
        var call = {
            paginationRequest: filter,
            submssionFormat: submissionFormat

        };
        
        //console.log("CALL");
        //console.log(call);
        var url = '/api/dashboard/dataSubmissionActivity';
        
        return http.post(url, call,{
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }

    const getDownloadCall = async (row) => {   

        //console.log(row);
        //console.log(submissionFormat);

        var url = null;
        var isTestCase = null;
        
        //CDA
        if(submissionFormat == 1){
            url = '/api/report/batchDetail';
            isTestCase=row.testCase;
        }
        //ALT
        if(submissionFormat == 0){
            url = '/api/report/altBatchDetail';
            var t = row.submitType;
            if(t==="T"){
                isTestCase="Y";
            }
            else{
                isTestCase="N";
            }
        }

        var settingName = row.cfSetting;


        var batchId = row.id;
        //console.log(url);

        return httpDownload.post(url, {"batchId": batchId, "isTestSubmission": isTestCase, "settingName": settingName},{ 
            responseType: 'blob',
            headers: {
                "Authorization": "Bearer " + loginInfo.token
            }
        });
    }

    const handleFileDownload = async (row) => {
        const res = await getDownloadCall(row);
        
        if (res) {
            //console.log(res);
            //console.log(res.headers);
            //console.log(res.headers['content-disposition']);
            // get filename from the res content-disposition
            const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            //console.log(filename)
            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a); // append the element to the dom
            a.click();
            a.remove(); // afterwards, remove the element  
        }
    }

    
    const formatType = (val) => {
        //console.log(val);
        if (val==="Y" || val==="T") {
           return "Test";
        }
        else if (val==="N" || val==="P"){
            return "Production";
        }
        else {
            return null;
        }
      
    }

    const handlePendingSftp = (pendingSftp) => {
        if (pendingSftp == "D") {
            return "";
        }

        return "Yes";
    }

    const getListCols = (selectedList, sortingInfo)=>{
        const listColumns = [];

        const handleDownloadData = function ( row ) {
            //console.log(row);
           handleFileDownload(row);
        }
        

        const nameState = function ({ rowName }) {
            //console.log("printout rowName", rowName);
            return { 
                id: rowName.id,
                backRedirect: {
                    path: location.pathname,
                    state: {
                        ...location.state,
                        tab: submissionFormat == 1 ? "CDA" : "Alt"
                    },
                }

               
            };
        } 

        const formatReport = function ( row  ){
            //console.log("REPORT");
            //console.log(row);
            return row.batchStatusId;
        
        }

         const isReportButton = function ( {row } ){
            //console.log("REPORT");
            //console.log(row);
            //console.log(row.batchStatusId)
            if(row.batchStatusId==4){
                return true;
            }
            else{
                return false;
            }
        
        }

        const getUniqueLinkPath = function ({ row }) {
            //console.log("printout rowName", row);
            if(submissionFormat == 0){
                return "/eventDataSubmission/altBatchDetail";
            }
            else{
                return "/eventDataSubmission/displayBatchDetail";  
            }
            
        }

        //CDA
        if(submissionFormat == 1){
            
                if(!(role != ROLES.L3.id && isVendor==true) && !(role != ROLES.PPCA.id && isVendor==false )){
                    listColumns.push(Datatable_Column({
                        name: "PSO ID", 
                        columnName: "submitPsoId", 
                        selectedRows: selectedList, 
                        sortable:true, 
                        sortFieldNum:4, 
                        sortingInfo:sortingInfo,
                    }))
                }
                

                listColumns.push(Datatable_Column({
                    name: "Batch ID", 
                    columnName:"id", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    isLink: ({row})=> {
                        //console.log(row);
                        //console.log(row.batchStatusId)
                        if(row.batchStatusId==5 || row.batchStatusId ==6 || row.batchStatusId ==7){
                            if(role == ROLES.PPCA.id){
                                return true;
                            }
                            else{
                                return false;
                            }
                        }
                        else{
                            return true;
                        }
                        
                    },
                    linkData: { title: "", pathname: getUniqueLinkPath, text: null, state: nameState },
                    sortingInfo:sortingInfo
                }))

                listColumns.push(Datatable_Column({
                    name: "Setting", 
                    columnName: "cfSetting", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortFieldNum:4, 
                    sortingInfo:sortingInfo,
                }))

                listColumns.push(Datatable_Column({
                    name:"Submission Type", 
                    columnName:"testCase", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortFieldNum:4, 
                    sortingInfo:sortingInfo,
                    formatFunction: formatType
                }))

                listColumns.push(Datatable_Column({
                    name:"Submission Date", 
                    columnName:"submitDate", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortFieldNum:4,
                    sortingInfo:sortingInfo,
                    formatFunction: formatDate
                }))
               
                listColumns.push(Datatable_Column({
                    name:"# of Files", 
                    columnName: "fileCount", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortFieldNum:4,
                    sortingInfo:sortingInfo,
                    //formatFunction: formatDate
                }))

                listColumns.push(Datatable_Column({
                    name:"Accepted", 
                    columnName:"accepted", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    //sortFieldNum:4,
                    sortingInfo:sortingInfo
                }))
                listColumns.push(Datatable_Column({
                    name:"Rejected", 
                    columnName:"rejected", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    //sortFieldNum:4,
                    sortingInfo:sortingInfo
                }))
  
                listColumns.push(Datatable_Column({
                    name:"Status", 
                    columnName: "batchStatus", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    //sortFieldNum:4,
                    sortingInfo:sortingInfo
                }))
                
                if(!(role != ROLES.PSOA.id && role != ROLES.PPCA.id && role != ROLES.L3.id)){
                    listColumns.push(Datatable_Column({
                        name:"Report", 
                        columnName:"batchStatusId", 
                        selectedRows: selectedList, 
                        sortable:false, 
                        sortFieldNum:4,
                        sortingInfo:sortingInfo,
                        isButton: isReportButton,
                        buttonData:  { 
                            action: handleDownloadData,     //Function to do when button is pressed
                            text: "Download",                 //If null, value for column is used
                            icon:   ICONS.download   //Icon for button, can be null
                        },
                        formatFunction: formatReport
                        
                    }))
                }
        }


        //ALT
        if(submissionFormat == 0){

                if(!(role != ROLES.L3.id && isVendor==true) && !(role != ROLES.PPCA.id && isVendor==false )){
                    listColumns.push(Datatable_Column({
                        name: "PSO ID", 
                        columnName: "psoId", 
                        selectedRows: selectedList, 
                        sortable:true, 
                        sortFieldNum:4, 
                        sortingInfo:sortingInfo,
                    }))
                }

                listColumns.push(Datatable_Column({
                    name: "Batch ID", 
                    columnName:"id", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    isLink: ({row})=> {
                        //console.log(row);
                        //console.log(row.altBatchStatusId)
                        if(row.altBatchStatusId==5 || row.altBatchStatusId ==6 || row.altBatchStatusId ==7){
                            if(role == ROLES.PPCA.id){
                                return true;
                            }
                            else{
                                return false;
                            }
                        }
                        else{
                            return true;
                        }
                        
                    },
                    linkData: { title: "", pathname: getUniqueLinkPath, text: null, state: nameState },
                    sortingInfo:sortingInfo
                }))

                listColumns.push(Datatable_Column({
                    name:"Submission Type", 
                    columnName:"submitType", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortFieldNum:4, 
                    sortingInfo:sortingInfo,
                    formatFunction: formatType
                }))

                listColumns.push(Datatable_Column({
                    name: "CF Version", 
                    columnName: "cfVersionCD",
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortFieldNum:4, 
                    sortingInfo:sortingInfo,
                }))

                listColumns.push(Datatable_Column({
                    name:"# of Files", 
                    columnName: "numOfFiles", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortFieldNum:4,
                    sortingInfo:sortingInfo,
                    //formatFunction: formatDate
                }))
                
                listColumns.push(Datatable_Column({
                    name:"Status", 
                    columnName:"altBatchStatusDesc", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    //sortFieldNum:4,
                    sortingInfo:sortingInfo
                }))

                listColumns.push(Datatable_Column({
                    name: "PSE Batch", 
                    columnName:"pseBatchId", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortingInfo:sortingInfo
                }))

                listColumns.push(Datatable_Column({
                    name:"Submission Date", 
                    columnName:"submitDate", 
                    selectedRows: selectedList, 
                    sortable:true, 
                    sortFieldNum:4,
                    sortingInfo:sortingInfo,
                    formatFunction: formatDate
                }))

                listColumns.push(Datatable_Column({
                    name:"Detail Report", 
                    columnName:"altBatchStatusId", 
                    isDataRow: true,
                    selectedRows: selectedList, 
                    sortable:false, 
                    sortFieldNum:4,
                    sortingInfo:sortingInfo,
                    isButton: ({row})=> {
                        //console.log("REPORTALT");
                        //console.log(row);
                        //console.log(row.altBatchStatusId)
                        if(row.altBatchStatusId==8 || row.altBatchStatusId ==9){
                            return true;
                        }
                        else{
                            return false;
                        }
                        
                    },
                    buttonData:  { 
                        action: handleDownloadData,     //Function to do when button is pressed
                        text: "Download",                 //If null, value for column is used
                        icon:   ICONS.download   //Icon for button, can be null
                    },
                    formatFunction: formatReport
                    
                }))

        }

        return listColumns;
      }

      const tableTitle = function () {
        //submissionFormat, submissionState
        if(submissionFormat==0){
            return "Alternate Data Submission Activity";
        }
        if(submissionFormat==1){
            return "CDA Data Submission Activity";
        }
      }
      
      const tableDescription = function() {
      	return "The table displays submissions over the past 180 days.";
 
      }
      const [selectedCount, setSelectedCount] = useState(0);

    const searchFieldText = () => {
        if(submissionFormat==0){    //Alt
            if(role==ROLES.PPCA.id){
                return "Search by PSO ID, Batch ID or Batch Status";
            }
            else{
                return 'Search by PSO ID, Batch ID or Batch Status';
            }
        }
        if(submissionFormat==1){    //CDA
            if(role==ROLES.PPCA.id){
                return "Search by PSO ID, Batch ID, Batch Status or Setting";
            }
            else{
                return 'Search by PSO ID, Batch ID, Batch Status or Setting';
            }
        }
    }
   

  return (
    <>
       
        { filter!=null ?
            <DatatableBase 

                tableClassName="dataSubmissionActivityTable" 
                getData={getTest} 
                uniqueId={"dataSubmissionActivityTable"+submissionFormat+"_"+submissionState}
                
                filter = {filter}
                setFilter={setFilter}

                getListCols={getListCols} 
                setSelectedCount={setSelectedCount} 
                hasSelectableRows={false} 
                searchFieldText={searchFieldText()} 
                
                datatableHeader={tableTitle()} 
                datatableDescription={tableDescription()}
                sortingColumn={sortColumn.sortField} 
                sortingOrder={sortColumn.sortDirection}
            >
 
            </DatatableBase>
            :null
        }  
    </>
  );
}

export default DataSubmissionActivityTable;